// Helpers de moeda BRL centralizados
// - formatBRL: número -> "R$ 1.234,56"
// - parseBRLToNumber: string qualquer -> número (ponto decimal)
// - onlyDigits: remove tudo exceto dígitos
// - formatFromDigits: recebe dígitos como centavos e devolve texto BRL

const br = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });

export function formatBRL(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return "";
  try {
    return br.format(value);
  } catch {
    return "";
  }
}

export function onlyDigits(input: string): string {
  return (input || "").replace(/\D+/g, "");
}

export function parseBRLToNumber(text: string): number {
  if (!text) return 0;
  // Aceita formatos como "R$ 1.234,56" ou "1234,56" ou "123456" (centavos)
  // Estratégia: manter apenas dígitos e considerar 2 casas decimais
  const digits = onlyDigits(text);
  if (!digits) return 0;
  // Interpretar como centavos
  const cents = parseInt(digits, 10);
  if (Number.isNaN(cents)) return 0;
  return cents / 100;
}

export function formatFromDigits(digits: string): string {
  const n = parseInt(digits || "0", 10) / 100;
  return formatBRL(n);
}

export function formatBRLCurrencyInput(value: string): string {
  return formatFromDigits(onlyDigits(value));
}

export function clampPrice(n: number, { min = 0, max = 9999999999999.99 } = {}): number {
  if (Number.isNaN(n)) return 0;
  if (n < min) return min;
  if (n > max) return max;
  return Math.round(n * 100) / 100;
}
